// Components
import taskListDataDecorator from './taskListDataDecorator';
import TaskList from './TaskList';

export default taskListDataDecorator(TaskList);
